// extracted by mini-css-extract-plugin
module.exports = {"no-img":"noImg_no-img_hL8Yy"};